<eds-simple-modal
  *ngIf="(isVisible$ | async) === true"
  [config]="modalConfig"
  id="subscriptionsProductsIiiModal"
  [showModal]="true"
  [showClose]="true"
  [disableCloseOnBackground]="true"
  (onClose)="onModalClose()"
>
  <div modal-header>
    <eds-title
      size="h3"
      [level]="3"
      [title]="'subscriptions.modal-update-title' | translate"
    ></eds-title>
  </div>
  <div
    modal-body
    [innerHTML]="'subscriptions.modal-update-text' | translate"
  ></div>
  <div modal-footer>
    <button
      id="btnSubsProductClose"
      class="ft__btn"
      edsButton="secondary"
      size="normal"
      (click)="onModalClose()"
      data-analytics-no-event="true"
    >
      <span class="ft__btn__txt">{{
        "subscriptions.dont-save-updates" | translate
      }}</span>
    </button>
    <button
      id="btnSubsProductSave"
      class="ft__btn"
      [class.subscriptions-products-iii-modal__footer-button-right--disabled]="
        isloading
      "
      edsButton="primary"
      size="normal"
      [noMargin]="true"
      (click)="updateDocs()"
      data-analytics-no-event="true"
    >
      <span class="ft__btn__txt">{{
        "subscriptions.save-updates" | translate
      }}</span>
    </button>
  </div>
</eds-simple-modal>
